import { render, staticRenderFns } from "./document-type.vue?vue&type=template&id=d2929824"
import script from "./document-type.vue?vue&type=script&lang=js"
export * from "./document-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports